<template>
  <v-app>
    <!-- <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>FERCAM</span>
        <span class="font-weight-light">Logistics & Transport</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat href="https://www.fercam.com" target="_blank">
        <span class="mr-2">Fercam</span>
      </v-btn>
      <span class="font-weight-light">easyUpload</span>
    </v-toolbar>-->
    
    <router-view />
    <!-- <v-content>
      <Main />
    </v-content> -->

    <VersionModal v-model="showVersionModal" />
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld'
import Main from "./components/Main";
import HLogger from "./plugins/HLogger";
import VersionModal from "./components/VersionModal.vue";
import { initVersionCheck } from "./services/versionCheck";
const Logger = new HLogger();
export default {
  name: "App",
  components: {
    Main,
    VersionModal
  },
  data: () => ({
    showVersionModal: false,
  }),
  mounted() {
    Logger.Trace("Accesso", "A");

    initVersionCheck(() => {
      this.showVersionModal = true;
    });
  }
};
</script>
